import { BaseEnv } from '@aipb/gulliver/env/model';
import { Injectable } from '@angular/core';
import { SetupHandler } from './setup.handler';

@Injectable({
  providedIn: 'root'
})
export class ScriptHandler extends SetupHandler {
  constructor() {
    super('script.handler');
  }

  handle(env: BaseEnv) {
    if (!env.scripts) return;

    env.scripts.forEach((s) => {
      const script = document.createElement('script');
      script.src = s;
      document.head.appendChild(script);

      this.addLogMessage(`added script ${s}`);
    });
  }
}
